import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function ComplianceSection() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-checkbox-circle-line', text: t('compliance_1') },
    { icon: 'ri-checkbox-circle-line', text: t('compliance_2') },
    { icon: 'ri-checkbox-circle-line', text: t('compliance_3') },
    { icon: 'ri-checkbox-circle-line', text: t('compliance_4') },
  ];

  return (
    <section id="compliance" className="py-24 bg-gradient-to-br from-blue-50 to-teal-50">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-5xl font-bold text-neutral-dark mb-4">
            {t('compliance_title')}
          </h2>
          <p className="text-xl text-neutral-text">
            {t('compliance_subtitle')}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="bg-white rounded-3xl shadow-xl p-12"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="flex items-start gap-4"
              >
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${feature.icon} text-2xl text-success`}></i>
                </div>
                <p className="text-lg text-neutral-dark font-medium pt-1">
                  {feature.text}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="bg-warning/10 border-2 border-warning/30 rounded-2xl p-6 flex items-start gap-4"
          >
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <i className="ri-alert-line text-2xl text-warning"></i>
            </div>
            <div>
              <h4 className="font-bold text-neutral-dark mb-2 text-lg">{t('compliance_notice_title')}</h4>
              <p className="text-neutral-text leading-relaxed">
                {t('compliance_notice_desc')}
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
